import { FormProvider } from '@/context/FormProvider';

import { type ApiKeyCreateFormValues, apiKeyCreateSchema } from '@/schemas/api-key.schema';

import type { Props } from '@/types/formik.type';

export const ApiKeyCreateFormProvider = ({ children, onSubmit }: Props<ApiKeyCreateFormValues>) => {
  const initialValues: ApiKeyCreateFormValues = {
    secret_name: '',
  };

  return (
    <FormProvider
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={apiKeyCreateSchema}
    >
      {children}
    </FormProvider>
  );
};
